export const addRemBodyClass = (className, remove) => {
  let cl = document.body.classList,
  hasClass = cl.contains(className);
  if (remove === false) {
    if (hasClass) {
      cl.remove(className);
    }
  } else {
    if (!hasClass) {
      cl.add(className);
    }
  }
  return cl;
}

export const addBodyClass = className => {
  return addRemBodyClass(className, true);
}

export const removeBodyClass = className => {
  return addRemBodyClass(className, false);
}

export const swapBodyClass = (classNameRem,classNameAdd) => {
  removeBodyClass(classNameRem);
  return addBodyClass(classNameAdd);
}